import Swal from "sweetalert2";

class SwalAlertClass {
    constructor(params = {}) {
        const defaultParams = {
            icon: "error",
            title: "",
            confirmButtonText: "",
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            target: "body",
            // Añadir atributos ARIA por defecto
            didOpen: (popup) => {
                popup.setAttribute("aria-modal", "true");
                popup.setAttribute("role", "dialog");
                popup.setAttribute("aria-labelledby", "swal2-title");
                popup.setAttribute("aria-describedby", "swal2-content");
                // Remover aria-hidden del elemento raíz para evitar conflictos
                const rootElement = document.getElementById("root");
                if (rootElement) {
                    rootElement.removeAttribute("aria-hidden");
                }
            },
        };
        this.Swal = Swal;
        this.params = {...defaultParams, ...params};
    }

    warning(title, text) {
        this.params.icon = "warning";
        this.params.title = title;
        this.params.text = text;
        return this.Swal.fire(this.params);
    }

    info(title, text) {
        this.params.icon = "info";
        this.params.title = title;
        this.params.text = text;
        return this.Swal.fire(this.params);
    }

    error(title, text) {
        this.params.icon = "error";
        this.params.title = title;
        this.params.text = text;
        return this.Swal.fire(this.params);
    }

    success(title, text) {
        this.params.icon = "success";
        this.params.title = title;
        this.params.text = text;
        return this.Swal.fire(this.params);
    }
    question(title, text) {
        this.params.icon = "question";
        this.params.title = title;
        this.params.text = text;
        return this.Swal.fire(this.params);
    }
    fire(title, text) {
        this.params.title = title;
        this.params.text = text;
        return this.Swal.fire(this.params);
    }
    showLoader() {
        return this.Swal.fire({
            title: this.params.title,
            allowOutsideClick: false,
            allowEscapeKey: false,
            target: "body",
            didOpen: (popup) => {
                popup.setAttribute("aria-modal", "true");
                popup.setAttribute("role", "dialog");
                this.Swal.showLoading();
            },
        });
    }
    hideLoader() {
        this.Swal.hideLoading();
        this.Swal.close();
    }
}

class SwalAlertChoice extends SwalAlertClass {
    constructor(params) {
        super(params);
        this.params = {
            ...this.params,
            cancelButtonText: "",
            showCancelButton: true,
            ...params,
        };
    }
}

class SwalToast extends SwalAlertClass {
    constructor(params) {
        super(params);
        this.params = {
            ...this.params,
            toast: true,
            position: "top-end",
            ...params,
        };
    }
}

export {SwalAlertClass, SwalAlertChoice, SwalToast};
